import React from "react";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography/Typography";
import styles from "./styles";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Title from "../ui/title";
import Content from "../ui/content";
import Back from "../ui/back";
import DeepLink from "../ui/deepLink";

import JobHeader from "../common/jobs/jobHeader";
import SignaltekResultsHeader from "../common/results/signaltekResultsHeader";
import SignaltekResultViewer from "../common/results/signaltekResultViewer";
import { resetResultsState } from "../../redux/actions";

class SignaltekResults extends React.Component {
  constructor(props) {
    super(props);
    const {
      pager,
      testsFilters,
      selectedTests,
      profile,
      preferences,
      job
    } = this.props;

    this.state = {
      pager: pager,
      totalTests: 0,
      testsFilters,
      selectedTests,
      subtest: "Summary",
      chartLineStyle: preferences ? preferences.chartLineStyle : "inverted",
      chartMeasurement: preferences ? preferences.chartMeasurement : "auto",
      chartMeasurementUnit: profile && profile.units ? profile.units : "meters",
      wiremapStandard: job && job.wiremapcolor ? job.wiremapcolor : "568B",
      chartMeasurementType: profile && profile.type ? profile.type : "events",
      showMargin: preferences ? preferences.showMargin : true,
      jobAttachmentsModal: false,
      uploadModal: false,
      jobid: pager.jid,
      testid: pager.tid,
      isBarClicked: false
    };

    this.previousTestId = 0;
    this.nextTestId = 0;
    this.currentTestIndex = 0;
    this.total = 0;
    this.onChangeResultsViewer = this.onChangeResultsViewer.bind(this);
  }
  setNavStates(props) {
    const { pager, testsFilters, selectedTests, results } = props;
    let selectedIds, index;

    if (selectedTests && selectedTests.length) {
      selectedIds = selectedTests.map(test => test.id);
      index = selectedIds.indexOf(parseInt(pager.tid, 10));
    }
    this.setState({
      pager: pager,
      totalTests:
        index !== -1 && selectedTests
          ? Object.keys(selectedTests).length
          : results.totalcount, // job.tests.length
      testsFilters,
      selectedTests
    });
  }

  setNavigation() {
    const { results } = this.props;
    const { pager, selectedTests } = this.state;
    let previousTestId, nextTestId, currentTestIndex, total, selectedIds, index;

    if (selectedTests && selectedTests.length) {
      selectedIds = selectedTests.map(test => test.id);
      index = selectedIds.indexOf(parseInt(pager.tid, 10));
    }

    if (selectedTests && selectedTests.length && index !== -1) {
      if (index === 0) {
        previousTestId = null;
        nextTestId = selectedIds[index + 1];
      } else if (index === selectedIds.length - 1) {
        previousTestId = selectedIds[index - 1];
        nextTestId = null;
      } else {
        previousTestId = selectedIds[index - 1];
        nextTestId = selectedIds[index + 1];
      }
      currentTestIndex = index + 1;
      total = selectedIds.length;
    } else {
      previousTestId = results.prevtestid;
      nextTestId = results.nexttestid;
      currentTestIndex = results.currentTestIndex;
      total = results.totalcount;
    }

    this.previousTestId = previousTestId;
    this.nextTestId = nextTestId === undefined ? null : nextTestId;
    this.currentTestIndex = currentTestIndex;
    this.total = total;
  }
  changeBarClick = clickState => {
    this.setState({ isBarClicked: clickState });
  };

  handleChartLineChange = e => {
    const { preferences, setPreferences } = this.props;
    setPreferences({
      ...preferences,
      chartLineStyle: e.target.value
    });
  };

  handleChartMeasurementChange = e => {
    const { preferences, setPreferences } = this.props;
    setPreferences({
      ...preferences,
      chartMeasurement: e.target.value
    });
  };

  handleChartMeasurementUnitChange = e => {
    const { profile, userUpdate } = this.props;
    this.setState({ chartMeasurementUnit: e.target.value });
    profile.units = e.target.value;
    userUpdate(profile);
  };

  handleChartMeasurementTypeChange = e => {
    const { profile, userUpdate } = this.props;
    this.setState({ chartMeasurementType: e.target.value });
    this.changeBarClick(false);
    profile.type = e.target.value;
    userUpdate(profile);
  };

  handleShowMargin = e => {
    const { preferences, setPreferences } = this.props;
    setPreferences({
      ...preferences,
      showMargin: e.target.checked
    });
  };

  handleWiremapStandardChange = e => {
    const { preferences, setPreferences, job } = this.props;
    this.setState({
      wiremapStandard: e.target.value
    });
    this.props.storeWiremapStandard(job.id, e.target.value);
  };

  render() {
    const {
      translate,
      job,
      results,
      getSubtestResults,
      // subtestResultsDisplay,
      // subtestResultsRemote,
      resetReducer,
      //subtestResultsWiremap,
      subtestSignaltekResults,
      preferences,
      attachments,
      getAttachments,
      deleteAttachment,
      attachmentDownload,
      uploadAttachment,
      showResults,
      showResultHeader,
      selectedCustomerName,
      selectedCustomerId,
      clearAttachments,
      getNetScanResult,
      netScanResultDetail,
      fetch,
      getsubtestWiremapResults,
      subtestWiremapResults,
      getsubtestFiberLengthLossResults,
      subtestFiberLengthLossResults,
      getsubtestPoeResults,
      subtestPoeResults,
      getsubtestMaxthroughputResults,
      subtestMaxthroughputResults,
      getsubtestUptimeResults,
      subtestUptimeResults,
      getsubtestUptimeResultsDetails,
      subtestUptimeResultsDetails,
      getsubtestUptimeResultsDetails_BarClick,
      subtestUptimeResultsDetails_BarClick,
      getsubtestSubTestsettingsResults,
      subtestSubTestSettingsResults,
      clearSubTestSettingsResult,
      getStatsResult,
      subtestStatsResults,
      impersonating,
      softwareUpdate,
      resetResultsState,
      fileUploadSettings,
    } = this.props;

    const {
      pager,
      subtest,
      chartMeasurementUnit,
      chartMeasurementType,
      jobid,
      testid,
      wiremapStandard,
      isBarClicked
    } = this.state;
    this.setNavigation();

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    let testList = [];
    results && results.datasettings
      ? Object.keys(results.datasettings).forEach(function(key) {
          results.datasettings[key] == true ? testList.push(key) : null;
        })
      : null;
    if (results) {
      return (
        <div style={{marginTop: margintop}}>
          <Title
            title={results.data.name}
            custTitle={
              selectedCustomerName && (
                <Back
                  title={translate("general_customers")}
                  link={"/customers"}
                />
              )
            }
            custName={
              selectedCustomerName && (
                <Back
                  title={selectedCustomerName}
                  link={`/customers/${selectedCustomerId}`}
                />
              )
            }
            back={<Back title={job.name} link={`/job/${job.id}`} />}
            deepLink={
              <DeepLink
                title={translate("general_jobs")}
                link={
                  selectedCustomerId ? `/jobs/${selectedCustomerId}` : "/jobs"
                }
              />
            }
          />
          <Content translate={translate}>
            <JobHeader
              job={job}
              translate={translate}
              isSelectionShow={false}
            />

            {showResultHeader ? (
              <SignaltekResultsHeader
                impersonating={impersonating}
                translate={translate}
                results={results}
                pager={pager}
                previousTest={this.previousTest}
                nextTest={this.nextTest}
                previousTestId={this.previousTestId}
                nextTestId={this.nextTestId}
                currentTestIndex={this.currentTestIndex}
                total={this.total}
                job={job}
                onChange={this.onChangeResultsViewer}
                subtest={subtest}
                handleChartLineChange={this.handleChartLineChange}
                handleChartMeasurementChange={this.handleChartMeasurementChange}
                handleChartMeasurementUnitChange={
                  this.handleChartMeasurementUnitChange
                }
                handleChartMeasurementTypeChange={
                  this.handleChartMeasurementTypeChange
                }
                handleShowMargin={this.handleShowMargin}
                handleWiremapStandardChange={this.handleWiremapStandardChange}
                chartLineStyle={
                  preferences ? preferences.chartLineStyle : "inverted"
                }
                chartMeasurement={
                  preferences ? preferences.chartMeasurement : "auto"
                }
                chartMeasurementUnit={chartMeasurementUnit}
                chartMeasurementType={chartMeasurementType}
                wiremapStandard={wiremapStandard}
                showMargin={preferences ? preferences.showMargin : false}
                selectedResult={result => {
                  this.setState({
                    pager: {
                      ...this.state.pager,
                      rid: result
                    }
                  });
                }}
                getAttachments={getAttachments}
                attachments={attachments}
                uploadAttachment={uploadAttachment}
                deleteAttachment={deleteAttachment}
                attachmentDownload={attachmentDownload}
                jobid={jobid}
                testid={testid}
                clearAttachments={clearAttachments}
                fileUploadSettings={fileUploadSettings}
              />
            ) : (
              <Typography>{translate("result_loading")}</Typography>
            )}
            {showResultHeader && !showResults && (
              <Typography>{translate("result_loading")}</Typography>
            )}
            {/* //  showResults &&
            // results.data &&
            // ((results.data.subtests && results.data.subtests.length) ||
            //   results.data.testedcabletype === "FiberCable" ||
            //   results.data.testedcabletype === "Fiber" ||
            //   (results.data.lfttest && results.data.lfttest.length)) */}
            {showResults && results.data && results.data.status ? (
              <SignaltekResultViewer
                impersonating={impersonating}
                job={job}
                translate={translate}
                results={results}
                pager={pager}
                subtest={subtest}
                getSubtestResults={getSubtestResults}
                subtestSignaltekResults={subtestSignaltekResults}
                // subtestResultsRemote={subtestResultsRemote}
                // subtestResultsDisplay={subtestResultsDisplay}
                // subtestResultsWiremap={subtestResultsWiremap}
                chartLineStyle={
                  preferences ? preferences.chartLineStyle : "inverted"
                }
                chartMeasurement={
                  preferences ? preferences.chartMeasurement : "auto"
                }
                chartMeasurementUnit={chartMeasurementUnit}
                chartMeasurementType={chartMeasurementType}
                // wiremapStandard={wiremapStandard}
                showMargin={preferences ? preferences.showMargin : false}
                resetReducer={resetReducer}
                onChangeResultsViewer={this.onChangeResultsViewer}
                getNetScanResult={getNetScanResult}
                netScanResultDetail={netScanResultDetail}
                fetch={fetch}
                getsubtestWiremapResults={getsubtestWiremapResults}
                subtestWiremapResults={subtestWiremapResults}
                getsubtestFiberLengthLossResults={getsubtestFiberLengthLossResults}
                subtestFiberLengthLossResults={subtestFiberLengthLossResults}
                getsubtestPoeResults={getsubtestPoeResults}
                subtestPoeResults={subtestPoeResults}
                getsubtestMaxthroughputResults={getsubtestMaxthroughputResults}
                subtestMaxthroughputResults={subtestMaxthroughputResults}
                getsubtestUptimeResults={getsubtestUptimeResults}
                subtestUptimeResults={subtestUptimeResults}
                getsubtestUptimeResultsDetails={getsubtestUptimeResultsDetails}
                subtestUptimeResultsDetails={subtestUptimeResultsDetails}
                getsubtestUptimeResultsDetails_BarClick={
                  getsubtestUptimeResultsDetails_BarClick
                }
                subtestUptimeResultsDetails_BarClick={
                  subtestUptimeResultsDetails_BarClick
                }
                getsubtestSubTestsettingsResults={
                  getsubtestSubTestsettingsResults
                }
                subtestSubTestSettingsResults={subtestSubTestSettingsResults}
                clearSubTestSettingsResult={clearSubTestSettingsResult}
                getStatsResult={getStatsResult}
                subtestStatsResults={subtestStatsResults}
                isBarClicked={isBarClicked}
                changeBarClick={this.changeBarClick}
                resetResultsState={resetResultsState}
              />
            ) : (
              showResults &&
              testList && (
                <div>
                  {/* <Typography>
                    {translate("no_fiberpower_meter_data")}
                  </Typography> */}
                  <p>{translate("configured_tests")}</p>
                  {testList.map(test => (
                    <p>{translate(test)}</p>
                  ))}
                </div>
              )
            )}
          </Content>
        </div>
      );
    } else {
      return <Typography>{translate("no_fiberpower_meter_data")}</Typography>;
    }
  }

  componentWillMount() {
    this.setNavStates(this.props);
    this.props.setSignaltek();
  }

  componentWillReceiveProps(nextProps) {
    const { pager } = nextProps;
    const { resetReducer, profile } = this.props;
    if (
      pager.tid !== this.props.pager.tid ||
      pager.jid !== this.props.pager.jid
    ) {
      resetReducer();
    }
    setTimeout(() => {
      this.setNavStates(nextProps);
    }, 1);
    if (
      !this.state.subtest.startsWith("qualification_") &&
      nextProps.results &&
      nextProps.results.data &&
      nextProps.results.data.subtests &&
      (nextProps.results.data.subtests.hasOwnProperty(
        this.state.subtest.toLowerCase()
      ) == false ||
        nextProps.results.data.subtests[this.state.subtest.toLowerCase()] ==
          null)
    ) {
      this.setState({
        subtest: "Summary"
      });
    }

    this.setState({
      jobid: pager.jid,
      testid: pager.tid,
      pager
    });

    if (profile) {
      this.setState({
        chartMeasurementUnit: profile.units,
        chartMeasurementType: profile.type ? profile.type : "events"
      });
    }
  }

  componentDidMount() {
    const { pager, selectedTests, setSelectedTests } = this.props;
    let selectedIds, index;
    if (selectedTests && selectedTests.length) {
      selectedIds = selectedTests.map(test => test.id);
      index = selectedIds.indexOf(parseInt(pager.tid, 10));

      if (index === -1) {
        setSelectedTests(null);
      }
    }
  }

  onChangeResultsViewer(subtest) {
    this.setState({ subtest });
  }

  componentWillUnmount() {
    const { resetResultsState, clearSignaltek } = this.props;
    resetResultsState();
    clearSignaltek();
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(SignaltekResults);




// WEBPACK FOOTER //
// ./src/components/results/signaltekresults.js